export default __webpack_public_path__ + "static/media/RSOrtiz.a8ffa2b3.jpg";